import * as React from "react";
import type { SVGProps } from "react";
const SvgVolumeX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 5h1a1 1 0 0 0-1.625-.78zM6 9v1a1 1 0 0 0 .625-.22zM2 9V8a1 1 0 0 0-1 1zm0 6H1a1 1 0 0 0 1 1zm4 0 .625-.78A1 1 0 0 0 6 14zm5 4-.625.78A1 1 0 0 0 12 19zm12.707-9.293a1 1 0 0 0-1.414-1.414zm-7.414 4.586a1 1 0 0 0 1.414 1.414zm1.414-6a1 1 0 1 0-1.414 1.414zm4.586 7.414a1 1 0 0 0 1.414-1.414zM10.375 4.22l-5 4 1.25 1.562 5-4zM6 8H2v2h4zM1 9v6h2V9zm1 7h4v-2H2zm3.375-.22 5 4 1.25-1.56-5-4zM12 19V5h-2v14zM22.293 8.293l-6 6 1.414 1.414 6-6zm-6 1.414 6 6 1.414-1.414-6-6z"
    />
  </svg>
);
export default SvgVolumeX;
